import axios from 'axios';

import {
  ABSENCES,
  CLIENT_ABSENCES,
  DELETE_CLIENT_ABSENCE_PERIOD,
  END_CLIENT_ABSENCE_PERIOD,
  GET_CLIENT_ABSENCE_REASONS,
  UPDATE_CLIENT_ABSENCE
} from '../endpoints';

type DeleteAbsenceOptions = {
  absenceId: number;
  startDate: string | null;
  endDate: string | null;
};

export const deleteAbsence = ({
  absenceId,
  startDate,
  endDate
}: DeleteAbsenceOptions) =>
  axios.delete(`${ABSENCES}/${absenceId}`, {
    params: {
      start: startDate ?? null,
      end: endDate ?? null
    }
  });

export type AppointmentIdentifier = { id: string; originalId: string | null };

export type ClientAbsence = {
  absentAppointments: AppointmentIdentifier[];
  clientAbsenceId: string;
  clientId: string;
  start: string;
  end: string;
  reasonId: string;
  description?: string;
};

export type GetClientAbsencesOptions = {
  clientId: string;
  startDate?: Date;
  endDate?: Date;
};

export const getClientAbsences = ({
  clientId,
  startDate,
  endDate
}: GetClientAbsencesOptions) =>
  axios.get<ClientAbsence[]>(CLIENT_ABSENCES, {
    params: {
      startDate,
      endDate
    },
    pathParams: {
      clientId
    }
  });

type ClientAbsenceReason = {
  id: string;
  name: string;
};

type CreateClientAbsenceRequest = {
  reasonId: string;
  description?: string;
  start: Date;
  end?: Date | null;
  absentAppointments: AppointmentIdentifier[] | null;
};

export type CreateClientAbsenceOptions = CreateClientAbsenceRequest & {
  clientId: string;
  onSuccess?: () => void;
};

export const getClientAbsenceReasons = () =>
  axios.get<ClientAbsenceReason[]>(GET_CLIENT_ABSENCE_REASONS);

export const createClientAbsenceRequest = async ({
  clientId,
  ...params
}: CreateClientAbsenceOptions) => {
  return await axios.post(CLIENT_ABSENCES, params, {
    pathParams: { clientId }
  });
};

export type UpdateClientAbsenceOptions = {
  clientId: string;
  clientAbsenceId: string;
  onSuccess?: () => void;
} & CreateClientAbsenceRequest;

export const updateClientAbsence = async ({
  clientId,
  clientAbsenceId,
  ...params
}: UpdateClientAbsenceOptions) => {
  return await axios.put(UPDATE_CLIENT_ABSENCE, params, {
    pathParams: { clientId, clientAbsenceId }
  });
};

export type EndClientAbsencePeriodOptions = {
  clientId: string;
  clientAbsenceId: string;
  end: string;
  onSuccess?: () => void;
};

export const endClientAbsencePeriod = async ({
  clientId,
  clientAbsenceId,
  end
}: EndClientAbsencePeriodOptions) => {
  return await axios.put(
    END_CLIENT_ABSENCE_PERIOD,
    { end },
    {
      pathParams: { clientId, clientAbsenceId }
    }
  );
};

export type DeleteClientAbsencePeriodOptions = {
  clientId: string;
  clientAbsenceId: string;
  onSuccess?: () => void;
};

export const deleteClientAbsencePeriod = async ({
  clientId,
  clientAbsenceId
}: DeleteClientAbsencePeriodOptions) => {
  return await axios.delete(DELETE_CLIENT_ABSENCE_PERIOD, {
    pathParams: { clientId, clientAbsenceId }
  });
};
